import React, { FC, useLayoutEffect } from 'react'
import { BackButton } from '~/src/components/atoms/Button/BackButton/BackButton'
import { ProtectedPage } from '~/src/components/templates'
import { ContainerInformation } from '~/src/components/pages/Order/ContainerOrder/ContainerOrderDetail/components/ContainerInformation'
import { Box } from '@mui/material'
import { ContainerOrderFile } from '~/src/components/pages/Order/ContainerOrder/ContainerOrderDetail/components/ContainerOrderFile'
import { useTranslation } from 'react-i18next'
import { TableItemDetail } from '~/src/components/pages/Order/ContainerOrder/ContainerOrderDetail/components/TableItemDetail'
import { TableContactOrder } from '~/src/components/pages/Order/ContainerOrder/ContainerOrderDetail/components/TableContactOrder'
import { useLocation } from 'react-router-dom'
import { containerRepository } from '~/src/repositories/index'
import { useMessage } from '~/src/hooks'
import { useGetContainer } from '~/src/components/pages/Order/ContainerOrder/ContainerOrderDetail/hooks/useGetContainer'
import { LoadingNormal } from '~/src/components/organisms'

/**
 * ContainerOrderDetail
 * @constructor
 */
export const ContainerOrderDetail: FC = (): JSX.Element => {
  const { t } = useTranslation()
  const location = useLocation()
  const { handleOpenWithSuccessMessage, handleOpenWithErrorMessage } = useMessage()
  // @ts-ignore
  const { id } = location.state.item as any

  const { data: containerData, error } = useGetContainer(id)

  useLayoutEffect(() => {
    if (error) handleOpenWithErrorMessage(error.message)
  }, [error])

  /**
   * patchMemo
   * メモの更新
   * @param text
   */
  const patchMemo = async (text: string): Promise<void> => {
    try {
      await containerRepository.patchContainerMemo(id, { note: text })
      handleOpenWithSuccessMessage('メモの更新しました')
    } catch (e) {
      console.log(e)
      handleOpenWithErrorMessage('メモの更新に失敗しました')
    }
  }

  /**
   * patchBalance
   * 残金更新処理
   * @param data
   */
  const patchBalance = async (data: number): Promise<void> => {
    try {
      await containerRepository.patchContainerBalance(id, { balance: data })
      handleOpenWithSuccessMessage('残金を更新しました')
    } catch (e) {
      console.log(e)
      handleOpenWithErrorMessage('残金の更新に失敗しました')
    }
  }

  if (!containerData && !error) {
    return <LoadingNormal />
  }

  return (
    <ProtectedPage pageTitle={t('container_order_detail.container_order_details')}>
      <BackButton location={location} />
      <Box sx={{ display: 'flex' }} marginBottom={'24px'}>
        {containerData && <ContainerInformation id={id} data={containerData?.container} />}
        {containerData && (
          <ContainerOrderFile
            containerId={containerData?.container.id}
            patchMemo={patchMemo}
            patchBalance={patchBalance}
            data={containerData?.containerFilesInfo}
            containerUserId={containerData?.user.id}
          />
        )}
      </Box>
      {containerData && (
        <TableItemDetail
          data={containerData?.containerItems}
          totalPrice={containerData?.itemsTotalPrice}
        />
      )}
      {containerData && containerData.user.id !== 0 && (
        <TableContactOrder userId={containerData.user.id} />
      )}
    </ProtectedPage>
  )
}
